import { alpha } from "@mui/material/styles";

const withAlphas = (color: any) => {
  return {
    ...color,
    alpha4: alpha(color.main, 0.04),
    alpha8: alpha(color.main, 0.08),
    alpha12: alpha(color.main, 0.12),
    alpha30: alpha(color.main, 0.3),
    alpha50: alpha(color.main, 0.5),
  };
};

export const neutral = {
  50: "#F9FAFB",
  100: "#F2F4F7",
  200: "#EAECF0",
  300: "#D0D5DD",
  400: "#98A2B3",
  500: "#667085",
  600: "#475467",
  700: "#344054",
  800: "#1D2939",
  900: "#101828",
};

export const orange = withAlphas({
  lightest: "#FFF4ED",
  light: "#FFCCA7",
  main: "#FF6B00",
  dark: "#CC5500",
  darkest: "#662B00",
  contrastText: "#FFFFFF",
});

export const error = withAlphas({
  lightest: "#FEF3F2",
  light: "#FEE4E2",
  main: "#F04438",
  dark: "#B42318",
  darkest: "#7A271A",
  contrastText: "#FFFFFF",
});

export const info = withAlphas({
  lightest: "#F5FAFF",
  light: "#B9E6FE",
  main: "#FF6B00",
  dark: "#CC5500",
  darkest: "#662B00",
  contrastText: "#FFFFFF",
});

export const success = withAlphas({
  lightest: "#F6FEF9",
  light: "#DCFAE6",
  main: "#FF6B00",
  dark: "#CC5500",
  darkest: "#662B00",
  contrastText: "#FFFFFF",
});

export const warning = withAlphas({
  lightest: "#FFFAEB",
  light: "#FEF0C7",
  main: "#FF6B00",
  dark: "#CC5500",
  darkest: "#662B00",
  contrastText: "#FFFFFF",
});

export const primary = withAlphas({
  lightest: "#FFF4ED",
  light: "#FFCCA7",
  main: "#FF6B00",
  dark: "#CC5500",
  darkest: "#662B00",
  contrastText: "#FFFFFF",
});

export const secondary = withAlphas({
  lightest: "#F9FAFB",
  light: "#F2F4F7",
  main: "#1D2939",
  dark: "#101828",
  darkest: "#0A0F1A",
  contrastText: "#FFFFFF",
});

export const background = {
  default: "#0F1521",
  paper: "#FFFFFF",
};

export const text = {
  primary: "#1D2939",
  secondary: "#475467",
  disabled: "#98A2B3",
};
